import { render, staticRenderFns } from "./AdminListaEncuestas.vue?vue&type=template&id=9212fa36&scoped=true"
import script from "./AdminListaEncuestas.vue?vue&type=script&lang=js"
export * from "./AdminListaEncuestas.vue?vue&type=script&lang=js"
import style0 from "./AdminListaEncuestas.vue?vue&type=style&index=0&id=9212fa36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9212fa36",
  null
  
)

export default component.exports